import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { invalidateEmailExecTemplates } from './useEmailExecTemplates';

export function useUpdateEmailExecAssistantTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.EmailExecAssistantTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (template: Api.EmailExecAssistantTemplate) => {
			return userSession.webServiceHelper.callAsync<Api.EmailExecAssistantTemplate>(
				`emailExecAssistant/templates/${template.id}`,
				'PUT',
				template
			);
		},
		onError,
		onSuccess,
		onSettled: () => {
			invalidateEmailExecTemplates();
		},
	});
}
